import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from '../../redux/user/actions';
import { Redirect, useHistory } from 'react-router-dom';

const ErrorMessage = ({ error, errorStack }) => {
    // this can be used to pass through the error stack.
    // This can be done via Email using the below prop for the anchor tag:
    // href={`mailto:michael@malibuitlabs.com?subject=Error Report&body=error: ${error}
    const escapedErrorStack = encodeURI(errorStack);

    const dispatch = useDispatch();
    const history = useHistory();

    const [shouldRedirect, setShouldRedirect] = useState(false);

    const { loginToken } = useSelector((state) => state.tokenReducer.tokens);
    console.log('loginToken: ', loginToken);

    const handleClick = () => {
        dispatch(userLogout());
        setShouldRedirect(true);
        window.location.reload();
    };

    return shouldRedirect ? (
        <Redirect to={'/login'} />
    ) : (
        <div style={{ backgroundColor: '#2fa89f', height: '700px' }}>
            <h5
                style={{
                    fontSize: '20px',
                    color: 'white',
                    textAlign: 'center',
                    paddingTop: '10rem',
                }}
            >
                Oops! it looks like something went wrong.
                <p>
                    Please{' '}
                    <span
                        style={{ color: 'red', cursor: 'pointer' }}
                        onClick={handleClick}
                    >
                        click here
                    </span>{' '}
                    to log out and try again. If the error persists, please
                    contact support.
                </p>
            </h5>
        </div>
    );
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorMessage.js